import {
  DistrictMapObject,
  EgibObject,
  Enablement,
  EnablementDto,
} from '@gk/gk-modules';
import {
  AuthorizedPersonToRegistryView,
  AuthorizedPersonToRegistryViewDto,
} from '../../../../services/authorized-person-to-registry-view/authorized-person-to-registry-view.model';
import { RangeType } from '../../../../services/parcel/parcel.model';
import { SharingPurpose } from '../../../../services/sharing-purpose/sharing-purpose.model';
import { NgbDateRange } from '../../../../utils/date-helper/date-helper.util';
import { LegalInterestAutocompleteItem } from '../new-request-form/new-request-form.model';

export const emptyToolType = 'emptyToolType';
export type EmptyToolType = typeof emptyToolType;

export class NewRequestModel {
  constructor(
    public applicantId: string,
    public purpose: SharingPurpose,
    public authorizedPersonsToRegistryView: AuthorizedPersonToRegistryView[],
    public period: NgbDateRange,
    public publicRegister: string,
    public districts: DistrictMapObject[],
    public parcels: EgibObject[],
    public wkt: string,
    public rangeType: RangeType,
    public enablement: Enablement,
    public isAgreement: boolean,
    public personalData?: boolean,
    public par1?: string,
    public par2?: string,
    public predefinedLegalInterest?: LegalInterestAutocompleteItem,
    public publicTaskCaseReference?: string,
    public typeOfSharing?: string,
    public dataBaseGml?: string,
  ) {}

  static getInitialStruct(): NewRequestModel {
    return {
      rangeType: RangeType.Parcels,
      period: {},
      enablement: Enablement.getInitialStruct(),
      personalData: true,
    } as NewRequestModel;
  }
}

export interface CzasDostepu {
  CzasDostepuOd: string;
  CzasDostepuDo: string;
}

export class PrzpZamowienieZakresRequestDto {
  constructor(
    public DzialkiUuids: null | string[],
    public ObrebIds: null | number[],
    public Wkt: null | string,
    public PozId: number,
  ) {}
}

export interface NewRequestApiModel {
  IdPetenta: string | number;
  CelId: string;
  Par1: string;
  Par2: string;
  UpowaznieniInfo: AuthorizedPersonToRegistryViewDto[];
  CzasDostepu: CzasDostepu;
  RejPublId: number;
  ZakresDaneOs?: boolean;
  Zakres: PrzpZamowienieZakresRequestDto;
  Pelnomocnictwo: EnablementDto;
  PodstawaId: number;
  SygnaturaZadPubl: string;
  IsPorozumienie: boolean;
}

export interface NewRequestResponse {
  ZamowId: number;
  ZamowNr: string;
  ZamowUuid: string;
}

export enum TypeOfSharing {
  Register = 'register',
  Gml = 'gml',
}
